export default "__VITE_ASSET__da465bf4__"